import { api } from "./api"
import type {
  QuestionnaireRequest,
  OnboardingProgress,
  ConformityScore,
  SiretCheckResponse,
  SignupRequest,
  ScaffoldingLevel,
} from "@/types/onboarding"
import type { SignupAttribution } from "@/lib/signup-attribution"

// ==================== Signup ====================

export function checkSiret(siret: string): Promise<SiretCheckResponse> {
  return api.get<SiretCheckResponse>(`/auth/check-siret/${encodeURIComponent(siret)}`)
}

export function signup(
  data: SignupRequest & Partial<{ attribution: SignupAttribution }>,
): Promise<{ message: string; user_id: string }> {
  return api.post<{ message: string; user_id: string }>("/auth/signup", data)
}

/** Organisme créé à la vérification : l'utilisateur est déjà connecté (cookies). */
export type VerifyEmailResponse = { message: string; user_id: string; tenant_id: string; tenant_slug: string }

export function verifyEmail(token: string): Promise<VerifyEmailResponse> {
  return api.post<VerifyEmailResponse>("/auth/verify-email", { token })
}

/** « Passer » le questionnaire d'accueil : il ne sera plus proposé. */
export function skipQuestionnaire(): Promise<void> {
  return api.post<void>("/onboarding/questionnaire/skip", {})
}

// ==================== Questionnaire ====================

export function submitQuestionnaire(data: QuestionnaireRequest): Promise<{ message: string }> {
  return api.post<{ message: string }>("/onboarding/questionnaire", data)
}

// ==================== Progress ====================

export function getOnboardingProgress(): Promise<OnboardingProgress> {
  return api.get<OnboardingProgress>("/onboarding/progress")
}

// ==================== Conformity ====================

export function getConformityScore(): Promise<ConformityScore> {
  return api.get<ConformityScore>("/onboarding/conformity-score")
}

// ==================== Scaffolding ====================

export function getScaffoldingLevel(entityType: string): Promise<ScaffoldingLevel> {
  return api.get<ScaffoldingLevel>("/onboarding/scaffolding", { entity_type: entityType })
}

// ==================== Demo ====================

export function switchToDemo(): Promise<{ message: string }> {
  return api.get<{ message: string }>("/demo/switch")
}
